import styled from 'styled-components';
// old design
export const TableBodyRow = styled.tr `
  &:nth-child(2n) {
    background: #f9f9f9;
  }
`;
// new design
export const TableBodyRowNew = styled.tr `
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.1);
  &:nth-child(2n) {
    background: rgba(255, 255, 255, 0.2);
  }
`;
export const TableBodyRowModal = styled.tr `
  z-index: 10;
  &::before {
    content: '';
    position: absolute;
    width: calc(100vw - 100px);
    max-width: 668px;
    height: 48px;
    left: 0;
    background: rgba(255, 255, 255, 0.1);
    z-index: -1;
    transition: all 0.3s;
  }
  &:nth-child(2n) {
    &::before {
      background: rgba(255, 255, 255, 0.2);
    }
  }
`;
